import { ErrorMessage, Field } from 'formik';
import Container from '../../containers/container';
import { VStack } from '../../layouts/stack.layout';

type Props = {
  name: string;
  label: string;
  // value: string;
  type: 'number' | 'text' | 'password' | 'textarea';
  placeholder?: string;
  maxLength?: number;
  rows?: number;
};

const styles = {
  'form-group__wrapper': 'w-full',
  'form-group__container':
    'form-group w-full border border-dark-gray rounded-md px-2 py-1 relative',
  'form-group__input': 'bg-inherit font-text',
  'form-group__label': 'font-text text-info text-2xs capitalize',
  'form-group__error': 'font-text text-info text-xs text-error',
};

function TextFormGroup(props: Props) {
  const { name, type, label, ...rest } = props;

  const getActualType = () => {
    switch (type) {
      case 'textarea':
        return { as: 'textarea' };
      default:
        return { type };
    }
  };

  return (
    <VStack gap="xs" extensions={styles['form-group__wrapper']}>
      <VStack gap="xs" colReverse extensions={styles['form-group__container']}>
        <Field
          id={name}
          name={name}
          className={styles['form-group__input']}
          {...getActualType()}
          {...rest}
        />
        <label htmlFor={name} className={styles['form-group__label']}>
          {label}
        </label>
      </VStack>
      <Container extensions={styles['form-group__error']}>
        <ErrorMessage name={name} />
      </Container>
    </VStack>
  );
}

export default TextFormGroup;
